import React, { PureComponent } from 'react';

import Icon from '~/core/scripts/components/Icon';
import { steps } from '~/kits/general/utils';
import { trackEvent } from '~/core/scripts/utils';

class Stepper extends PureComponent {
  constructor() {
    super();

    this.isPrevActive = false;
  }

  nextStep = () => {
    this.isPrevActive = true;
    this.props.nextStep();
    trackEvent('next_area', 1, 'class_B');

    if (this.props.currentStep === steps.length - 1) {
      trackEvent('all_areas', 1, null);
    }
  }

  render() {
    const { prevStep, currentStep } = this.props;
    const nextLabel = steps[(currentStep + 1) % steps.length];

    return (
      <div className="stepper">
        <button onClick={prevStep} className="btn btn__prev" disabled={!this.isPrevActive}>
          <Icon type="arrow-left" />
        </button>
        <div className="stepper__current">
          {steps[currentStep]} <span className="light">({currentStep + 1}/17)</span>
        </div>
        <button onClick={this.nextStep} className="btn btn__next">
          {nextLabel}<Icon type="arrow-left" />
        </button>
      </div>
    );
  }
}

export default Stepper;
